<template>
    <section class="features-wrap">
        <div class="container">
            <div class="features">
                <div class="feature-list">
                    <template v-for="(feature, index) in features">

                        <div class="single-feature"  :key="index" v-if="feature.title">
                        
                            <div class="feature-icon">
                                <i :class="feature.icon"></i>
                            </div>

                            <div class="feature-details">
                                <h6>{{ feature.title }}</h6>
                                <span>{{ feature.subtitle }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['features'],
    };
</script>
